import { Route, Routes } from "react-router-dom";
import Userlayout from "../layout/Userlayout";
import NotFoundPage from "../pages/NotFoundPage";
import { PrivateRoute } from "./PrivateRoutes";


import SecurityPermissionDashBoard from "../pages/securityPermission/SecurityPermissionDashboard";
import PermissionProfileMainPage from "../pages/permission-profile/PermissionProfileMainPage";
import PermissionProfileDetailsPage from "../pages/permission-profile/PermissionProfileDetailsPage";
import AddPermissionProfilePage from "../pages/permission-profile/AddPermissionProfilePage";
import MenuAssignToProfileDetailsPage from "../pages/permission-profile/MenuAssignToProfileDetailsPage";
import ProfileAssignToUserListPage from "../pages/profile-assign-to-user/ProfileAssignToUserListPage";
import ProfileAssignToUserDetailsPage from "../pages/profile-assign-to-user/ProfileAssignToUserDetailsPage";
import ProfileAssignToUserAddNewPage from "../pages/profile-assign-to-user/ProfileAssignToUserAddNew";
import MenuAssignToUserListPage from "../pages/menu-assign-to-user-list/MenuAssignToUserListPage";
import MenuAssignToUserDetailsPage from "../pages/menu-assign-to-user-list/MenuAssignToUserDetailsPage";
import UserDeliveryAppPage from "../pages/user-delivery-app/UserDeliveryAppPage";
import UserDeliveryAppDetailsPage from "../pages/user-delivery-app/UserDeliveryAppDetailsPage";
import UserDeliveryAppAddNew from "../pages/user-delivery-app/UserDeliveryAppAddNew";
import ModuleListPage from "../pages/module-page/ModuleListPage";
import ModuleDetailsPage from "../pages/module-page/ModuleDetailsPage";
import AddNewModulePage from "../pages/module-page/AddNewModulePage";
import ParentMenuPage from "../pages/parent-menu/ParentMenuPage";
import ParentMenuDetailsPage from "../pages/parent-menu/ParentMenuDetailsPage";
import ChildMenuPage from "../pages/child-menu/ChildMenuPage";
import AddNewChildMenuPage from "../pages/child-menu/AddNewChildMenuPage";
import ChildMenuDetailsPage from "../pages/child-menu/ChildMenuDetailsPage";
import AddParentMenuPage from "../pages/parent-menu/AddParentMenuPage";


function SecurityPermissionRoutes() {
      return (
            <>
                  <Userlayout>
                        <Routes>
                              <Route exact path='/dashboard' element={
                                    <PrivateRoute>  <SecurityPermissionDashBoard /> </PrivateRoute>}>
                              </Route>

                              <Route exact path='/create-profile' element={
                                    <PrivateRoute>  <PermissionProfileMainPage /> </PrivateRoute>}>
                              </Route>


                              <Route exact path='/create-profile/details/:id' element={
                                    <PrivateRoute>  <PermissionProfileDetailsPage /> </PrivateRoute>}>
                              </Route>

                              <Route exact path='/create-profile/add-new' element={
                                    <PrivateRoute>  <AddPermissionProfilePage /> </PrivateRoute>}>
                              </Route>


                              <Route exact path='/menu-assign-to-role' element={
                                    <PrivateRoute>  <PermissionProfileMainPage /> </PrivateRoute>}>
                              </Route>

                              <Route exact path='/menu-assign-to-role/details/:id' element={
                                    <PrivateRoute>  <MenuAssignToProfileDetailsPage /> </PrivateRoute>}>
                              </Route>


                              <Route exact path='/profile-assign-to-user' element={
                                    <PrivateRoute>  <ProfileAssignToUserListPage /> </PrivateRoute>}>
                              </Route>


                              <Route exact path='/profile-assign-to-user/add-new' element={
                                    <PrivateRoute>  <ProfileAssignToUserAddNewPage /> </PrivateRoute>}>
                              </Route>

                              <Route exact path='/profile-assign-to-user/details/:id' element={
                                    <PrivateRoute>  <ProfileAssignToUserDetailsPage /> </PrivateRoute>}>
                              </Route>

                              <Route exact path='/menu-assign-to-user' element={
                                    <PrivateRoute>  <MenuAssignToUserListPage /> </PrivateRoute>}>
                              </Route>

                              <Route exact path='/menu-assign-to-user/details/:id' element={
                                    <PrivateRoute>  <MenuAssignToUserDetailsPage /> </PrivateRoute>}>
                              </Route>


                              {/* Delivery APP Routes */}
                              <Route exact path='/user-delivery-app' element={
                                    <PrivateRoute>  <UserDeliveryAppPage /> </PrivateRoute>}>
                              </Route>


                              <Route exact path='/user-delivery-app/details/:id' element={
                                    <PrivateRoute>  <UserDeliveryAppDetailsPage /> </PrivateRoute>}>
                              </Route>

                              <Route exact path='/user-delivery-app/add-new' element={
                                    <PrivateRoute>  <UserDeliveryAppAddNew /> </PrivateRoute>}>
                              </Route>

                              {/* Module List Routes */}
                              <Route exact path='/module-list' element={
                                    <PrivateRoute>  <ModuleListPage /> </PrivateRoute>}>
                              </Route>



                              <Route exact path='/module-list/details/:id' element={
                                    <PrivateRoute>  <ModuleDetailsPage /> </PrivateRoute>}>
                              </Route>

                              <Route exact path='/module-list/add-new' element={
                                    <PrivateRoute>  <AddNewModulePage /> </PrivateRoute>}>
                              </Route>

                              {/* Parent Menu Routes */}
                              <Route exact path='/menu-parent' element={
                                    <PrivateRoute>  <ParentMenuPage /> </PrivateRoute>}>
                              </Route>

                              <Route exact path='/menu-parent/details/:id' element={
                                    <PrivateRoute>  <ParentMenuDetailsPage /> </PrivateRoute>}>
                              </Route>
                              {/* AddParentMenuPage */}
                              <Route exact path='/menu-parent/add-new' element={
                                    <PrivateRoute>  <AddParentMenuPage /> </PrivateRoute>}>
                              </Route>



                              {/* Child Menu Routes */}
                              <Route exact path='/menu-child' element={
                                    <PrivateRoute>  <ChildMenuPage /> </PrivateRoute>}>
                              </Route>

                              <Route exact path='/menu-child/add-new' element={
                                    <PrivateRoute>  <AddNewChildMenuPage /> </PrivateRoute>}>
                              </Route>

                              <Route exact path='/menu-child/details/:id' element={
                                    <PrivateRoute>  <ChildMenuDetailsPage /> </PrivateRoute>}>
                              </Route>




                              <Route path="/*" element={<NotFoundPage />}></Route>
                        </Routes>
                  </Userlayout>

            </>
      );
}

export default SecurityPermissionRoutes;